module.exports = __webpack_public_path__ + "img/NANACOFC.552eecba.png";